<template>
  <div class="swiper__skeleton d-flex wd-overflow-hidden" :class="skeletonWrapperClass">
    <div v-for="index in 3" :key="index" :class="swiperCellClass">
      <v-skeleton-loader class="" :style="swiperImgSkeletonStyle" :width="props.slideWidth" type="ossein" />
      <v-skeleton-loader v-if="props.hasBannerDescription" :class="swiperDescSkeletonClass" :width="props.slideWidth" type="ossein" />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  slideWidth: number
  isMobile: boolean
  isSingleSlidePerView: boolean
  isImageSizeLarge: boolean
  isCategoryUiType: boolean
  hasBannerDescription: boolean
}

const props = defineProps<Props>()

const skeletonWrapperClass = computed(() => [
  { mobile: props.isMobile, 'has-banner-description': props.hasBannerDescription, 'wd-pl-5 xs:wd-pl-0': props.isCategoryUiType },
])
const swiperCellClass = computed(() => (props.isMobile ? 'wd-mr-2' : 'wd-mr-5'))
const swiperImgSkeletonStyle = computed(() => {
  const { height, aspectRatio } = getBannerSlideStyle({
    isSingleSlidePerView: props.isSingleSlidePerView,
    isMobile: props.isMobile,
    isImageSizeLarge: props.isImageSizeLarge,
  })

  return { height, 'aspect-ratio': aspectRatio }
})
const swiperDescSkeletonClass = computed(() => (props.isCategoryUiType ? 'wd-my-2 xs:wd-my-4 wd-h-12' : 'wd-h-44px'))
</script>
